import { useEffect, useState } from 'react';
import getClient from 'utilities/startplusGraphql';
import { Queries } from 'apollo';

const useGetMyFiles = () => {
  const [state, setState] = useState({ data: {}, loading: true, error: null });
  const fetchData = () => {
    getClient()
      .then(startPlusClient =>
        startPlusClient.query({
          query: Queries.GetMyFiles,
        }),
      )
      .then(response => {
        const { myFiles, completedOffers } = response.data;
        setState({
          data: { myFiles, completedOffers, isAuthenticated: true },
          loading: false,
          error: null,
        });
      })
      .catch(error => setState({ data: {}, loading: false, error }));
  };
  useEffect(fetchData, []);
  return [state.data, state.loading, state.error, fetchData];
};

export default useGetMyFiles;
